if (!customElements.get('studio-session-tabs')) {
  customElements.define('studio-session-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
      const nav = this.querySelector('[role="tablist"]');
      if (!this.tabs.length) return;
      nav.hidden = false;
      this.activate(0);
      this.addEventListener('click', event => {
        const tab = event.target.closest('[role="tab"]');
        if (tab && this.contains(tab)) this.activate(this.tabs.indexOf(tab));
      });
      nav.addEventListener('keydown', event => {
        const index = this.tabs.indexOf(event.target);
        if (index < 0) return;
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        this.activate(next);
        this.tabs[next].focus();
      });
      this.addEventListener('shopify:block:select', event => {
        const panel = event.target.closest('[role="tabpanel"]');
        const index = this.panels.indexOf(panel);
        if (index >= 0) {
          this.activate(index);
          const details = event.target.closest('details');
          if (details) details.open = true;
        }
      });
    }
    activate(index) {
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
        this.panels[i].hidden = i !== index;
      });
    }
  });
}
